import { CustomerPartner } from "src/utils/CustomerPartner";

interface IPartnerContractLinks {
    dataProcessingAgreement: string;
    frameworkAgreement: string;
}

const WW_CONTRACT_LINKS: IPartnerContractLinks = {
    dataProcessingAgreement: "https://www.wwimmo.ch/wp-content/uploads/2023/06/Auftragsverarbeitungsvertrag.pdf",
    frameworkAgreement: "https://www.wwimmo.ch/rahmenvertrag/"
};

const EXTENSO_CONTRACT_LINKS: IPartnerContractLinks = {
    dataProcessingAgreement: "https://www.extenso.ch/avv",
    frameworkAgreement: "http://extenso.ch/avb-portal"
};

export const getPartnerContractLinks = (partner?: number): IPartnerContractLinks => {
    if (partner === CustomerPartner.EXTENSO) {
        return EXTENSO_CONTRACT_LINKS;
    }

    return WW_CONTRACT_LINKS;
};
